export enum FlagModifier {
  LIGHT = 'flag--light',
  MARGIN = 'flag--margin',
}
